import { SoDateRangePreset } from './so-date-range-picker.interfaces';

function addDays(date: Date, days: number) {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  return d;
}

function subMonths(date: Date, months: number) {
  const targetMonth = date.getMonth() - months;
  const lastDayOfTargetMonth = new Date(date.getFullYear(), targetMonth + 1, 0).getDate();
  const d = new Date(date);
  d.setDate(Math.min(date.getDate(), lastDayOfTargetMonth));
  d.setMonth(targetMonth);
  return d;
}

function startOfDay(date: Date) {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
}

function endOfDay(date: Date) {
  const d = new Date(date);
  d.setHours(23, 59, 59, 999);
  return d;
}

function startOfWeekMonday(date: Date) {
  const d = startOfDay(date);
  const day = (d.getDay() + 6) % 7;
  d.setDate(d.getDate() - day);
  return d;
}

function endOfWeekMonday(date: Date) {
  const start = startOfWeekMonday(date);
  const end = endOfDay(addDays(start, 6));
  return end;
}

function getLastDayOfMonth(month: number, year: number, monthDifferece: number = 0) {
  return endOfDay(new Date(year, month + 1 - monthDifferece, 0));
}

function getFirstDayOfMonth(month: number, year: number, monthDifferece: number = 0) {
  return startOfDay(new Date(year, month - monthDifferece, 1));
}

export function buildPresets(referenceDate: Date = new Date()): SoDateRangePreset[] {
  const todayDate = referenceDate;

  const thisWeekStart = startOfWeekMonday(todayDate);
  const thisWeekEnd = endOfWeekMonday(todayDate);

  const lastWeekStart = addDays(thisWeekStart, -7);
  const lastWeekEnd = addDays(thisWeekEnd, -7);

  return [
    { label: 'Hoy', range: { start: startOfDay(todayDate), end: endOfDay(todayDate) }, active: true, omit: false },
    { label: 'Ayer', range: { start: startOfDay(addDays(todayDate, -1)), end: endOfDay(addDays(todayDate, -1)) }, active: false, omit: false },
    { label: 'Semana actual', range: { start: thisWeekStart, end: thisWeekEnd }, active: false, omit: false },
    { label: 'Semana anterior', range: { start: lastWeekStart, end: lastWeekEnd }, active: false, omit: false },
    {
      label: 'Mes actual',
      range: {
        start: getFirstDayOfMonth(todayDate.getMonth(), todayDate.getFullYear()),
        end: getLastDayOfMonth(todayDate.getMonth(), todayDate.getFullYear()),
      },
      active: false,
      omit: false,
    },
    {
      label: 'Mes anterior',
      range: {
        start: getFirstDayOfMonth(todayDate.getMonth(), todayDate.getFullYear(), 1),
        end: getLastDayOfMonth(todayDate.getMonth(), todayDate.getFullYear(), 1),
      },
      active: false,
      omit: false,
    },
    {
      label: 'Últimos 3 meses',
      range: { start: startOfDay(subMonths(todayDate, 3)), end: endOfDay(todayDate) },
      active: false,
      omit: false,
    },
    {
      label: 'Últimos 6 meses',
      range: { start: startOfDay(subMonths(todayDate, 6)), end: endOfDay(todayDate) },
      active: false,
      omit: false,
    },
    {
      label: 'Últimos 12 meses',
      range: { start: startOfDay(subMonths(todayDate, 12)), end: endOfDay(todayDate) },
      active: false,
      omit: false,
    },
  ];
}

export const PRESETS: SoDateRangePreset[] = buildPresets();
